import { getText } from '@/utils/text/text';

export const EXCLUSIVE_LAUNCH_ZONE_DEFAULTS = {
    ANNOUNCEMENT_TEXT: getText({ text: 'components.exclusivePreLaunch.comingSoon' }),
    VIEW_TRAILER_TEXT: getText({ text: 'components.exclusivePreLaunch.viewTrailer' }),
    PLAY_NOW_BUTTON: getText({ text: 'components.exclusivePreLaunch.playNow' })
};
